import { FC, MutableRefObject, ReactElement, Ref, useContext, useMemo, useState } from 'react'
import '../timeline/Timeline.scss'
import { InternalContext } from '../contexts/InternalContext'
import { Position } from '../../types'
import { useFormatMilliseconds } from '../hooks/useFormatMilliseconds'
import { useVisiblePositionGetPercent } from '../hooks/useVisiblePositionGetPercent'
import { useAnimation } from '../../hooks/useAnimation'

interface Props {
  render: (props: { position: Position; ref: Ref<HTMLDivElement> }) => ReactElement
  time?: boolean
}

export const PlaybackPosition: FC<Props> = (props) => {
  const {
    playbackCursorPosition,
    audioPlayer: { playback },
  } = useContext(InternalContext)

  return playbackCursorPosition || playback ? <PlaybackPositionBody {...props} /> : null
}

const PlaybackPositionBody: FC<Props> = ({ time, render }) => {
  const {
    audioPlayer: { playback, getPlaybackPosition },
    playbackCursorPosition,
  } = useContext(InternalContext)
  const [element, setElement] = useState<HTMLDivElement | null>(null)
  const getPercent = useVisiblePositionGetPercent()
  const formatMilliseconds = useFormatMilliseconds()
  const positionRef = useMemo<MutableRefObject<Position>>(
    () => ({ current: (playback && getPlaybackPosition()) || playbackCursorPosition || 0 }),
    [playbackCursorPosition, playback, getPlaybackPosition],
  )

  useAnimation(() => {
    if (element) {
      positionRef.current = getPlaybackPosition()

      element.style.left = `${getPercent(positionRef.current)}%`

      if (time) {
        element.innerText = formatMilliseconds(positionRef.current)
      }
    }
  }, playback && element)

  return render({
    position: positionRef.current,
    ref: setElement,
  })
}
